/**
 * Restores the spec-compliant Promise.try(fn, ...args) semantics.
 *
 * Umi's auto-generated polyfill imports core-js's `esnext.promise.try`
 * (a pre-spec stage-2 implementation that calls the callback with zero
 * arguments and force-overwrites the native Promise.try). pdf.js 4.x calls
 * Promise.try(action, data, sink) and relies on every argument being
 * forwarded, so the poisoned implementation makes `sink` undefined and
 * throws "Cannot set properties of undefined (setting 'onPull')".
 */
export function restoreSpecPromiseTry(): void {
  Object.defineProperty(Promise, 'try', {
    configurable: true,
    writable: true,
    value: function (callbackfn: (...args: unknown[]) => unknown, ...args: unknown[]) {
      return Promise.resolve().then(() => callbackfn(...args));
    },
  });
}
